import { Button, Form, Input, Modal, DatePicker, Select } from "antd";
import dayjs from "dayjs";

import { isDatePast } from "../../../../utils/helper";

const CreateEditProblemModal = ({
  isModalOpen = false,
  isEdit = false,
  ratingOptions = [],
  initialValues = {},
  setIsModalOpen = () => {},
  handleCreateEditProblem = () => {}
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFormSubmit = (values) => {
    handleCreateEditProblem(values);
  };

  let formInitialValues = initialValues || {};

  return (
    <Modal
      title="Create New Problem"
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <Form
        form={form}
        initialValues={isEdit ? formInitialValues : {}}
        name="new_cp_sheet_problem_form"
        onFinish={handleFormSubmit}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Please enter the problem name!"
            }
          ]}
        >
          <Input placeholder="Some Cool Name!" />
        </Form.Item>
        <Form.Item
          name="link"
          label="Link"
          rules={[
            {
              required: true,
              message: "Please enter the problem link!"
            }
          ]}
        >
          <Input placeholder="Link of the contest" />
        </Form.Item>
        <Form.Item
          name="rating"
          label="Rating"
          rules={[
            {
              required: true,
              message: "Please select a rating!"
            }
          ]}
        >
          <Select options={ratingOptions || []} showSearch allowClear />
        </Form.Item>

        <Form.Item name="videoSolutionLink" label="Video solution link">
          <Input />
        </Form.Item>
        <Form.Item name="conceptIdea" label="Concept Idea">
          <Input placeholder="E.g. Prefix Sum idea, DFS Pattern" />
        </Form.Item>
        <Form.Item
          name="solutionReleaseDate"
          label="Solution Release Date"
          getValueProps={(value) => ({ value: value ? dayjs(value) : null })}
        >
          <DatePicker disabledDate={isDatePast} />
        </Form.Item>

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CreateEditProblemModal;
